const displaySpinner = () => {
  modal().classList.add("opaque");
  spinner().classList.remove("hidden");
};

const hideSpinner = () => {
  modal().classList.remove("opaque");
  spinner().classList.add("hidden");
};

const modal = () => document.getElementById("SendInvoiceByEmailModal");

const spinner = () => modal().querySelector("#sending-spinner");

export { displaySpinner, hideSpinner };
